/**
 * Zentrale Übersetzung von API-Fehlern in eine für den Nutzer anzeigbare Nachricht.
 * Domänen liefern über den Backend-`detail`-Text nur noch den fachlichen Inhalt;
 * die Darstellungsentscheidung (welcher Text bei welchem Fehlertyp) liegt hier.
 */
import { ApiError } from "./client";

export type ErrorSeverity = "error" | "warning" | "info";

export interface ParsedApiError {
  message: string;
  severity: ErrorSeverity;
}

const GENERIC_SERVER_ERROR = "Serverfehler, bitte später erneut versuchen";
const GENERIC_NETWORK_ERROR = "Keine Verbindung zum Server möglich";

/**
 * Übersetzt einen aus `api.get/post/put/patch/delete` geworfenen Fehler in eine
 * einheitliche Nachricht. 401 wird hier bewusst nicht behandelt – der endet nicht
 * mehr in dieser Utility (siehe `client.ts`/`handleTokenRefresh`), sondern löst
 * zentral das `SessionExpiredModal` aus.
 */
export function parseApiError(err: unknown): ParsedApiError {
  if (err instanceof ApiError) {
    if (err.statusCode >= 500) {
      return { message: GENERIC_SERVER_ERROR, severity: "error" };
    }
    return { message: err.detail, severity: "error" };
  }

  if (err instanceof TypeError) {
    // fetch wirft TypeError bei Netzwerkfehlern (offline, DNS, CORS, …)
    return { message: GENERIC_NETWORK_ERROR, severity: "error" };
  }

  return {
    message: err instanceof Error ? err.message : GENERIC_SERVER_ERROR,
    severity: "error",
  };
}
